import React from 'react';

const Loader = () => {
  return (
    <section className="flex items-center justify-center xl:w-[80%] w-[100%] h-[100%] ">

   
<div  className="dot-spinner">
    <div className="dot-spinner__dot"></div>
    <div className="dot-spinner__dot"></div>
    <div className="dot-spinner__dot"></div>
    <div className="dot-spinner__dot"></div>
    <div className="dot-spinner__dot"></div>
    <div className="dot-spinner__dot"></div>
    <div className="dot-spinner__dot"></div>
    <div className="dot-spinner__dot"></div>
</div>
 </section>
  );
}


export default Loader;
